const imgs = {
    gardener: new URL('../img/gardener.webp', import.meta.url),
    agregator: new URL('../img/agregator rurkowy weibang.webp', import.meta.url),
    zageszczarka1: new URL('../img/zageszczarka belle120.webp', import.meta.url),
    kompresor: new URL('../img/bezolejowy kompresor.webp', import.meta.url),
    dakr1: new URL('../img/dakr.webp', import.meta.url),
    spawarka: new URL('../img/deca spawarka.webp', import.meta.url),
    dmuchawa1: new URL('../img/dmiuchawa bg86.webp', import.meta.url),
    dmuchawa2: new URL('../img/dmuchawa sh56.webp', import.meta.url),
    drabina: new URL('../img/drabina.webp', import.meta.url),
    nozyce1: new URL('../img/elektryczne nozyce do zywoplotu.webp', import.meta.url),
    glebogryzarka: new URL('../img/glebogryzarka viking hb 560.webp', import.meta.url),
    kosa: new URL('../img/kosa spalinowa shihl fs 240.webp', import.meta.url),
    fs87: new URL('../img/fs87.webp', import.meta.url),
    kosiarka1: new URL('../img/kosiarka briggs.webp', import.meta.url),
    kosiarka2: new URL('../img/kosiarka spalinowa castel.webp', import.meta.url),
    kosiarka3: new URL('../img/kosiarka spalinowa z napedem viking.webp', import.meta.url),
    minikoparka: new URL('../img/minikoparka jbc 80818.webp', import.meta.url),
    mlotowiertarka: new URL('../img/mlotowiertarka.webp', import.meta.url),
    ms193: new URL('../img/ms193.webp', import.meta.url),
    ms200: new URL('../img/ms200.webp', import.meta.url),
    ms391: new URL('../img/ms391.webp', import.meta.url),
    nozyce2: new URL('../img/nozyce spalinowe.webp', import.meta.url),
    odkurzacz: new URL('../img/odkurzacz przemysłowy.webp', import.meta.url),
    opryskiwacz: new URL('../img/opryskiwacz spalinowy stihl.webp', import.meta.url),
    przeczepka: new URL('../img/przeczepka.webp', import.meta.url),
    rebak: new URL('../img/rebak timberwolf.webp', import.meta.url),
    siewnik: new URL('../img/siewnik wolf garten.webp', import.meta.url),
    szlifierka1: new URL('../img/szlifierka katowa.webp', import.meta.url),
    szlifierka2: new URL('../img/szlifierka zyrafa.webp', import.meta.url),
    taczki: new URL('../img/taczki cedrus.webp', import.meta.url),
    ts420: new URL('../img/ts420.webp', import.meta.url),
    walec: new URL('../img/walec napowieczacz.webp', import.meta.url),
    wertykulator: new URL('../img/wertykulator world.webp', import.meta.url),
    zageszczarka2: new URL('../img/zageszczarka 196cc.webp', import.meta.url),
    zageszczarka3: new URL('../img/zageszczarka belle.webp', import.meta.url),
    zywoplotnica2: new URL('../img/zywoplotnica.webp', import.meta.url),
    fs55: new URL('../img/fs55.webp', import.meta.url),
    laserk: new URL('../img/laserk.webp', import.meta.url),
    nozyce3: new URL('../img/nozyce akumlatorowe.webp', import.meta.url),
    kombii: new URL('../img/kombii system.webp', import.meta.url),
    stihlMh685: new URL('../img/stihl-mh-685.png', import.meta.url),
    weibangWertykulator: new URL('../img/weibang-wertykulator.jpg', import.meta.url),
    crawler: new URL('../img/crawler.webp', import.meta.url),
    avant630: new URL('../img/63000.webp', import.meta.url),
};

export default imgs;
